const BASE_URL = 'https://api.dev.auxo.dk';

/**
 * Henter menupunkter fra CMS og sorterer dem efter 'order'
 */
export async function getMenuItems() {
  try {
    const res = await fetch(`${BASE_URL}/public/content/menu_items`);
    if (!res.ok) throw new Error('Kunne ikke hente menupunkter');
    const data = await res.json();
    return data.sort((a, b) => (a.order || 0) - (b.order || 0));
  } catch (err) {
    console.error('CMS Menu Error:', err);
    // Fallback menu hvis API fejler
    return [
      { label: 'Forside', href: '/', order: 1 },
      { label: 'Om os', href: '/om-os', order: 2 },
      { label: 'Brød', href: '/broed', order: 3 },
      { label: 'Brunsviger', href: '/brunsviger', order: 4 },
      { label: 'Kager', href: '/kager', order: 5 },
      { label: 'Bestilling', href: '/bestilling', order: 6 },
      { label: 'Galleri', href: '/galleri', order: 7 },
      { label: 'Kontakt', href: '/kontakt', order: 8 }
    ];
  }
}

/**
 * Henter en side baseret på dens slug_name via v2-endepunktet
 */
export async function getPageBySlug(slug) {
  try {
    const res = await fetch(`${BASE_URL}/public/v2/content/pages?slug_name=${slug}`);
    if (!res.ok) throw new Error(`Kunne ikke hente side: ${slug}`);
    const data = await res.json();
    if (data && data.items && data.items.length > 0) {
      return data.items[0];
    }
    return null;
  } catch (err) {
    console.error(`CMS Page Error (${slug}):`, err);
    return null;
  }
}

/**
 * Henter et galleri baseret på dets slug_name via v2-endepunktet
 */
export async function getGalleryBySlug(slug) {
  try {
    const res = await fetch(`${BASE_URL}/public/v2/content/galleri?slug_name=${slug}`);
    if (!res.ok) throw new Error(`Kunne ikke hente galleri: ${slug}`);
    const data = await res.json();
    if (data && data.items && data.items.length > 0) {
      return data.items[0];
    }
    return null;
  } catch (err) {
    console.error(`CMS Gallery Error (${slug}):`, err);
    return null;
  }
}
